import {
  StringOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';

export type SignatureFields =
  | 'analyst_1_signature'
  | 'analyst_2_signature'
  | 'physician_signature'
  | 'parent_guardian_signature';

export class ConsentToTreatment {
  id: number = 0;
  bip_id: number = 0;
  patient_id: string = '';
  client_id: number = 0;
  analyst_1_signature: string = '';
  analyst_1_signature_date: string = '';
  analyst_1_signature_placeholder: boolean = false;
  analyst_2_signature: string = '';
  analyst_2_signature_date: string = '';
  analyst_2_signature_placeholder: boolean = false;
  physician_signature: string = '';
  physician_signature_date: string = '';
  physician_signature_placeholder: boolean = false;
  parent_guardian_signature: string = '';
  parent_guardian_signature_date: string = '';
  parent_guardian_signature_placeholder: boolean = false;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  constructor(data: Partial<ConsentToTreatment>) {
    Object.assign(this, data);
    this.analyst_1_signature_date = StringOrNullOrUndefined(this.analyst_1_signature_date) ?? '';
    this.analyst_1_signature_placeholder = BooleanOrNullOrUndefined(this.analyst_1_signature_placeholder) ?? false;
    this.analyst_2_signature_date = StringOrNullOrUndefined(this.analyst_2_signature_date) ?? '';
    this.analyst_2_signature_placeholder = BooleanOrNullOrUndefined(this.analyst_2_signature_placeholder) ?? false;
    this.physician_signature_date = StringOrNullOrUndefined(this.physician_signature_date) ?? '';
    this.physician_signature_placeholder = BooleanOrNullOrUndefined(this.physician_signature_placeholder) ?? false;
    this.parent_guardian_signature_date = StringOrNullOrUndefined(this.parent_guardian_signature_date) ?? '';
    this.parent_guardian_signature_placeholder = BooleanOrNullOrUndefined(this.parent_guardian_signature_placeholder) ?? false;
  }
  static getDefault(): ConsentToTreatment {
    return {
      id: 0,
      bip_id: 0,
      patient_id: '',
      client_id: 0,
      analyst_1_signature: '',
      analyst_1_signature_date: '',
      analyst_1_signature_placeholder: false,
      analyst_2_signature: '',
      analyst_2_signature_date: '',
      analyst_2_signature_placeholder: false,
      physician_signature: '',
      physician_signature_date: '',
      physician_signature_placeholder: false,
      parent_guardian_signature: '',
      parent_guardian_signature_date: '',
      parent_guardian_signature_placeholder: false,
    };
  }
}
